/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */


import React, {useRef, useState } from "react";



export const ContactForm: React.FC = () => {

    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [message, setMessage] = useState("");

    const handleChange = (e: any) => {

        if(e.target.id === "messageName") {
            setName(e.target.value);
        }

        if(e.target.id === "messageEmail") {
            setEmail(e.target.value);
        }

        if(e.target.id === "messageMessage") {
            setMessage(e.target.value);
        }
    }
    
    const handleSend = () => {
        window.open(`mailto:admin@uoscape.co.za?subject=Message%20from:%20${name}&body=Name:%09${name}%0AEmail:%09${email}%0A%0A${message}`);
    }

    return (
        <>
        <form>
            <div className="d-flex flex-column gap-1 pb-2">
                <label htmlFor="messageName" className="jc-txt-body fw-6">Name</label>
                <input value={name} onChange={handleChange} type="text" id="messageName" className="form-control" placeholder="Your full name" required />
            </div>
            <div className="d-flex flex-column gap-1 pb-2">
                <label htmlFor="messageEmail" className="jc-txt-body fw-6">Email</label>
                <input value={email} onChange={handleChange} type="email" id="messageEmail" className="form-control" placeholder="Your valid email" required />
            </div>
            <div className="d-flex flex-column gap-1 pb-2">
                <label htmlFor="messageMessage" className="jc-txt-body fw-6">Message</label>
                <textarea value={message} onChange={handleChange} id="messageMessage" className="form-control" placeholder="Your message" style={{minHeight: "100px"}} required></textarea>
            </div>
            <div className="d-flex justify-content-end">
                <button onClick={handleSend} type="submit" className="btn-submit btn btn-dark jc-txt-body jc-txt-light">Send</button>
            </div>
        </form>
        </>
    );
}